/**
 * This file is a component for E2 UI Customization
 */
 import React, {useState, useEffect} from 'react';
 import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
 import ScreenShareOutlinedIcon from '@material-ui/icons/ScreenShareOutlined';

 export default function EmailShowMessage(props)
 {
     const [showMessage, setShowMessage] = useState(false);
 
     /** Set showMessage to value being passed through props */
     useEffect(() => {
         setShowMessage(props.value);
     },[props.value]);
     
     /**Handle changes to live chat checkbox */
     const handleShowMessage = () => {
         setShowMessage(!showMessage);
         props.onChange(!showMessage)
     }
 
     return(
         <div>
             <Grid container direction="row" alignItems="center">
                 <Grid item>
                     <FormControlLabel
                     control={
                         <Checkbox
                         checked={showMessage}
                         onChange={handleShowMessage}
                         name="showMessage"
                         color="primary"
                         />
                     }
                     label="Show Message"
                     />
                 </Grid>
                 <Grid item>
                     <Tooltip title="Toggles the button that allows the agent to view the email message.">
                         <ScreenShareOutlinedIcon color="primary"/>
                     </Tooltip>
                 </Grid>
             </Grid>
         </div>
     );
 }
 
 